import request from "../utils/request";

// 后端 dataSetIds 为逗号分隔字符串；调用方可能传数组或已序列化的字符串
function normalizeDataSetIds(dataSetIds) {
  if (typeof dataSetIds === "string") {
    return dataSetIds.length > 0 ? dataSetIds : undefined;
  }
  if (!Array.isArray(dataSetIds) || dataSetIds.length === 0) {
    return undefined;
  }
  return dataSetIds.join(",");
}

//获取列表
export function getCategoryList(params) {
  return request({
    url: `/category/list?pageNum=${params.currentPage}&pageSize=${params.currentPageSize}&name=${params.name}&type=${params.type}&remark=${params.remark}&pageId=${params.pageId}`,
    method: "get",
  });
}
//复制分类
export function copyCategory(id) {
  return request({
    url: `/category/copy`,
    method: "post",
    data: {
      id,
    },
  });
}

/**
 * 分类资源转为独享：生成新资源实体 + 仅当前分类换绑（列表条数不变）。
 * wallpaperIds 省略 / undefined = 该分类下全部关联；传 [] = 不处理。
 */
export function copyCategoryResources({ categoryId, wallpaperIds }) {
  return request({
    url: `/category/copyResources`,
    method: "post",
    data: {
      categoryId,
      wallpaperIds,
    },
  });
}

//更具id查询数据
export function getCategoryById(params) {
  return request({
    url: "/category/query?id=" + params.id,
  });
}

//删除分类
export function deleteCategory(params) {
  return request({
    url: "/category/delete",
    method: "post",
    data: {
      id: params.id,
    },
  });
}

//更新分类
export function editCategory(params) {
  return request({
    url: "/category/update",
    method: "post",
    data: {
      categoryCO: {
        id: params.id,
        name: params.name,
        type: params.type,
        title: params.title,
        icon: params.backgroundUrl,
        country: JSON.stringify(params.country),
        appVersion: JSON.stringify(params.appVersion),
        iosApiVersion: JSON.stringify(params.iosVersion),
        androidApiVersion: JSON.stringify(params.androidVersion),
        remark: params.comment,
      },
    },
  });
}

//新增分类
export function createCategory(params) {
  return request({
    url: "/category/add",
    method: "post",
    data: {
      categoryCO: {
        name: params.name,
        type: params.type,
        title: params.title,
        icon: params.backgroundUrl,
        country: JSON.stringify(params.country),
        appVersion: JSON.stringify(params.appVersion),
        iosApiVersion: JSON.stringify(params.iosVersion),
        androidApiVersion: JSON.stringify(params.androidVersion),
        remark: params.comment,
      },
    },
  });
}

//上线或下线
export function onOrOffCategory(params) {
  return request({
    url: "/category/onOrOff",
    method: "post",
    data: {
      id: params.id,
    },
  });
}
//获取所有的数据集
export function getAllDataList() {
  return request({
    url: "/dataset/all",
  });
}
//查询分类关联资源
export function listWallpaperById(params) {
  return request({
    url: "/category/listWallpaperById",
    method: "get",
    params: {
      pageNum: params.pageNum,
      pageSize: params.pageSize,
      categoryId: params.id,
      wallpaperName: params.name,
      wallpaperType: params.wallpaperType,
      wallpaperTypes: params.wallpaperTypes,
      stickerKind: params.stickerKind,
      wallpaperStatus: params.wallpaperStatus,
      dataSetId: params.dataSetId,
      dataSetIds: normalizeDataSetIds(params.dataSetIds),
    },
  });
}
//批量删除关联资源
export function deleteWallpaperByIds(params) {
  return request({
    url: "/category/deleteCategoryWallpapers",
    method: "post",
    data: {
      categoryId: params.categoryId,
      wallpaperIds: params.wallpaperIds,
    },
  });
}
//分类关联资源新建页面查询接口
export function selectWallpaperPageByCategoryId(params) {
  return request({
    url: "/category/selectWallpaperPageByCategoryId",
    method: "get",
    params: {
      pageNum: params.pageNum,
      pageSize: params.pageSize,
      categoryId: params.id,
      wallpaperName: params.name,
      wallpaperType: params.type,
      wallpaperTypes: params.wallpaperTypes,
      stickerKind: params.stickerKind,
      dataSetIds: normalizeDataSetIds(params.dataSetIds),
    },
  });
}

//分类关联资源新建页面修改
export function updateCategoryWallpaper(params) {
  return request({
    url: "/category/updateCategoryWallpaper",
    method: "post",
    data: {
      categoryId: params.categoryId,
      defaultPriority: params.defaultPriority,
      deleteIds: params.deleteIds,
      data: params.data,
    },
  });
}

//修改优先值
export function updatePriority(params) {
  return request({
    url: "/category/updatePriority",
    method: "post",
    data: {
      categoryId: params.categoryId,
      wallpaperId: params.wallpaperId,
      priority: params.priority,
      dataSets: params.dataSets,
    },
  });
}

//查询优先级
export function queryPriorityAndDataSet(params) {
  return request({
    url: `/category/queryPriorityAndDataSet?wallpaperId=${params.wallpaperId}&categoryId=${params.categoryId}`,
    method: "get",
  });
}

//上传excel
export function uploadExcel(params, file) {
  return request({
    url: `/category/importResourceList?categoryId=${params.id}&importType=${params.type}`,
    method: "post",
    data: file,
  });
}